export default "__VITE_ASSET__DutJQJPd__"